<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content=" National Park Entry & Fee Collection System" name="description"/>
      <meta content="County Development Team" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- Custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
      <title> National Park Entry & Fee Collection</title>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18"> NATIONAL PARK ENTRY & FEE COLLECTION</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">Park Management</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Park Statistics Cards -->
            <div class="row">
              <div class="col-xl-3 col-md-6">
                <div class="card park-card bg-success text-white">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-white-50 mb-1">Today's Visitors</p>
                        <h4 class="mb-0 text-white">{{ formatNumber(parkStats.todayVisitors) }}</h4>
                        <p class="text-white-50 mb-0">
                          <i class="mdi mdi-trending-up"></i> +12% from yesterday
                        </p>
                      </div>
                      <div class="flex-shrink-0">
                        <i class="mdi mdi-account-group font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card park-card bg-primary text-white">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-white-50 mb-1">Today's Revenue</p>
                        <h4 class="mb-0 text-white">{{ formatPrice(parkStats.todayRevenue) }}</h4>
                        <p class="text-white-50 mb-0">
                          <i class="mdi mdi-trending-up"></i> Target: {{ formatPrice(250000) }}
                        </p>
                      </div>
                      <div class="flex-shrink-0">
                        <i class="mdi mdi-cash-multiple font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card park-card bg-info text-white">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-white-50 mb-1">Vehicles in Park</p>
                        <h4 class="mb-0 text-white">{{ formatNumber(parkStats.vehiclesInPark) }}</h4>
                        <p class="text-white-50 mb-0">
                          Max capacity: 500 vehicles
                        </p>
                      </div>
                      <div class="flex-shrink-0">
                        <i class="mdi mdi-car-multiple font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card park-card bg-warning text-white">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-white-50 mb-1">Active Permits</p>
                        <h4 class="mb-0 text-white">{{ formatNumber(parkStats.activePermits) }}</h4>
                        <p class="text-white-50 mb-0">
                          Annual: {{ parkStats.annualPermits }}
                        </p>
                      </div>
                      <div class="flex-shrink-0">
                        <i class="mdi mdi-card-account-details font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Park Management Interface -->
            <div class="row">
              <!-- Entry Management -->
              <div class="col-xl-8">
                <div class="card">
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">Park Entry Management ()</h4>
                      <div>
                        <button @click="showNewEntryModal" class="btn btn-primary me-2">
                          <i class="mdi mdi-ticket"></i> New Entry
                        </button>
                        <button @click="showBulkEntryModal" class="btn btn-secondary me-2">
                          <i class="mdi mdi-bus"></i> Group Entry
                        </button>
                        <button @click="showAnnualPermitModal" class="btn btn-info">
                          <i class="mdi mdi-card-account-details"></i> Issue Permit
                        </button>
                        <button @click="createSamplePermit" class="btn btn-warning ms-2">
                          <i class="mdi mdi-test-tube"></i> Sample Permit
                        </button>
                        <button @click="createAndPrintSampleTicket" class="btn btn-success ms-2">
                          <i class="mdi mdi-printer"></i> Sample Ticket
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Entry Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <div class="col-md-3">
                        <label class="form-label mb-1">Entry Type:</label>
                        <select v-model="selectedEntryType" @change="filterEntries()" class="form-select">
                          <option value="">All Types</option>
                          <option value="CITIZEN">Citizen</option>
                          <option value="RESIDENT">Resident</option>
                          <option value="NON_RESIDENT">Non-Resident</option>
                          <option value="STUDENT">Student</option>
                          <option value="VEHICLE">Vehicle Only</option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="form-label mb-1">Status:</label>
                        <select v-model="selectedStatus" @change="filterEntries()" class="form-select">
                          <option value="">All Status</option>
                          <option value="IN_PARK">In Park</option>
                          <option value="EXITED">Exited</option>
                          <option value="EXPIRED">Expired</option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="form-label mb-1">Date:</label>
                        <input type="date" v-model="selectedDate" @change="filterEntries()"
                               class="form-control" :max="today">
                      </div>

                      <div class="col-md-3">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="searchQuery" @input="filterEntries()" type="text" class="form-control"
                                 placeholder="Ticket, vehicle, name...">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Entry Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th>Ticket #</th>
                          <th>Visitor Details</th>
                          <th>Entry Type</th>
                          <th>Vehicle</th>
                          <th>Entry Time</th>
                          <th class="text-end">Fees Paid</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="entry in filteredEntries" :key="entry.ticketNumber">
                          <td>
                            <span class="fw-semibold">{{ entry.ticketNumber }}</span>
                            <br>
                            <small class="text-muted">{{ entry.paymentMethod }}</small>
                          </td>
                          <td>
                            <div>
                              <strong>{{ entry.visitorName }}</strong>
                              <br>
                              <small class="text-muted">{{ entry.idNumber }}</small>
                              <br>
                              <small class="text-muted">{{ entry.phoneNumber }}</small>
                            </div>
                          </td>
                          <td>
                            <span class="badge" :class="getEntryTypeBadge(entry.entryType)">
                              {{ entry.entryType }}
                            </span>
                            <br>
                            <small>{{ entry.visitorCount }} visitors</small>
                          </td>
                          <td>
                            <div v-if="entry.vehicleReg">
                              <strong>{{ entry.vehicleReg }}</strong>
                              <br>
                              <small class="text-muted">{{ entry.vehicleType }}</small>
                            </div>
                            <span v-else class="text-muted">No vehicle</span>
                          </td>
                          <td>
                            <div>
                              {{ formatTime(entry.entryTime) }}
                              <br>
                              <small class="text-muted">Gate {{ entry.entryGate }}</small>
                            </div>
                          </td>
                          <td class="text-end">
                            <span class="fw-semibold">{{ formatPrice(entry.totalFees) }}</span>
                            <br>
                            <small class="text-muted">
                              Park: {{ formatPrice(entry.parkFees) }}
                              <br>
                              Vehicle: {{ formatPrice(entry.vehicleFees) }}
                            </small>
                          </td>
                          <td>
                            <span class="badge" :class="getStatusBadge(entry.status)">
                              {{ entry.status }}
                            </span>
                            <br>
                            <small class="text-muted">{{ getTimeInPark(entry) }}</small>
                          </td>
                          <td>
                            <div class="d-flex">
                              <button @click="viewEntryDetails(entry)"
                                      class="btn btn-primary btn-sm me-1"
                                      data-bs-toggle="modal" data-bs-target="#entryDetailModal">
                                <i class="mdi mdi-eye"></i>
                              </button>
                              <div class="dropdown">
                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                  <i class="bx bx-dots-vertical"></i>
                                </button>
                                <ul class="dropdown-menu">
                                  <li v-if="entry.status === 'IN_PARK'">
                                    <a class="dropdown-item" @click="recordExit(entry)">
                                      <i class="mdi mdi-exit-run me-2"></i>Record Exit
                                    </a>
                                  </li>
                                  <li><a class="dropdown-item" @click="printTicket(entry)">
                                    <i class="mdi mdi-printer me-2"></i>Print Ticket</a></li>
                                  <li><a class="dropdown-item" @click="sendTicketSMS(entry)">
                                    <i class="mdi mdi-message me-2"></i>Send SMS</a></li>
                                  <li><a class="dropdown-item" @click="extendEntry(entry)">
                                    <i class="mdi mdi-clock-plus me-2"></i>Extend Time</a></li>
                                  <li><a class="dropdown-item text-danger" @click="voidEntry(entry)">
                                    <i class="mdi mdi-cancel me-2"></i>Void Entry</a></li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-success mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Park Entries</h4>
                        <p>Fetching visitor data...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="filteredEntries.length < 1 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Entries Found</h4>
                        <p>No park entries match your current filter criteria.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Revenue Analytics -->
                <div class="card mt-3">
                  <div class="card-header bg-white border-bottom">
                    <h5 class="card-title mb-0">Today's Revenue Breakdown</h5>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-8">
                        <canvas id="revenueChart" height="100"></canvas>
                      </div>
                      <div class="col-md-4">
                        <div class="mt-4">
                          <div v-for="category in revenueCategories" :key="category.name"
                               class="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <i :class="category.icon" :style="{color: category.color}"></i>
                              <span class="ms-2">{{ category.name }}</span>
                            </div>
                            <strong>{{ formatPrice(category.amount) }}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Right Panel -->
              <div class="col-xl-4">
                <!-- Live Entry Monitor -->
                <div class="card">
                  <div class="card-header bg-white border-bottom">
                    <h5 class="card-title mb-0">
                      <i class="mdi mdi-pulse text-success me-2"></i>
                      Live Entry Monitor
                    </h5>
                  </div>
                  <div class="card-body p-0" style="max-height: 400px; overflow-y: auto;">
                    <div v-for="activity in liveActivities" :key="activity.id"
                         class="d-flex align-items-center p-3 border-bottom">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-xs">
                          <span class="avatar-title rounded-circle"
                                :class="getActivityIcon(activity.type).class">
                            <i :class="getActivityIcon(activity.type).icon"></i>
                          </span>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1">{{ activity.description }}</h6>
                        <p class="text-muted mb-0">
                          <small>{{ activity.gate }} • {{ activity.time }}</small>
                        </p>
                      </div>
                      <div class="flex-shrink-0">
                        <span class="badge bg-success">
                          {{ formatPrice(activity.amount) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Gate Status -->
                <div class="card mt-3">
                  <div class="card-header bg-white border-bottom">
                    <h5 class="card-title mb-0">
                      <i class="mdi mdi-gate text-primary me-2"></i>
                      Gate Status ()
                    </h5>
                  </div>
                  <div class="card-body">
                    <div v-for="gate in gateStatus" :key="gate.name" class="mb-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <h6 class="mb-0">{{ gate.name }}</h6>
                        <span class="badge" :class="gate.status === 'OPEN' ? 'bg-success' : 'bg-danger'">
                          {{ gate.status }}
                        </span>
                      </div>
                      <div class="row text-center">
                        <div class="col-4">
                          <small class="text-muted d-block">Entries</small>
                          <strong>{{ gate.todayEntries }}</strong>
                        </div>
                        <div class="col-4">
                          <small class="text-muted d-block">Exits</small>
                          <strong>{{ gate.todayExits }}</strong>
                        </div>
                        <div class="col-4">
                          <small class="text-muted d-block">Revenue</small>
                          <strong>{{ formatPrice(gate.revenue) }}</strong>
                        </div>
                      </div>
                      <div class="progress mt-2" style="height: 5px;">
                        <div class="progress-bar bg-success" role="progressbar"
                             :style="{width: (gate.todayEntries / 500 * 100) + '%'}"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Fee Structure -->
                <div class="card mt-3">
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="card-title mb-0">
                        <i class="mdi mdi-cash text-warning me-2"></i>
                        Current Fee Structure
                      </h5>
                      <button @click="editFeeStructure" class="btn btn-sm btn-outline-primary">
                        <i class="mdi mdi-pencil"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body">
                    <h6 class="text-primary mb-2">Park Entry Fees</h6>
                    <table class="table table-sm">
                      <tbody>
                      <tr v-for="fee in feeStructure.entry" :key="fee.category">
                        <td>{{ fee.category }}</td>
                        <td class="text-end">
                          <strong>{{ formatPrice(fee.adult) }}</strong>
                          <br>
                          <small class="text-muted">Child: {{ formatPrice(fee.child) }}</small>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <h6 class="text-primary mb-2 mt-3">Vehicle Fees</h6>
                    <table class="table table-sm">
                      <tbody>
                      <tr v-for="fee in feeStructure.vehicle" :key="fee.type">
                        <td>{{ fee.type }}</td>
                        <td class="text-end"><strong>{{ formatPrice(fee.amount) }}</strong></td>
                      </tr>
                      </tbody>
                    </table>

                    <div class="alert alert-info mt-3 mb-0">
                      <i class="mdi mdi-information me-2"></i>
                      <small>Special rates apply for school groups and research permits</small>
                    </div>
                  </div>
                </div>

                <!-- Quick Stats -->
                <div class="card mt-3">
                  <div class="card-header bg-white border-bottom">
                    <h5 class="card-title mb-0">
                      <i class="mdi mdi-chart-line text-info me-2"></i>
                      Performance Metrics
                    </h5>
                  </div>
                  <div class="card-body">
                    <div class="mb-3">
                      <div class="d-flex justify-content-between mb-1">
                        <span>Revenue Target</span>
                        <strong>{{ Math.round(parkStats.todayRevenue / 250000 * 100) }}%</strong>
                      </div>
                      <div class="progress">
                        <div class="progress-bar bg-success" role="progressbar"
                             :style="{width: (parkStats.todayRevenue / 250000 * 100) + '%'}">
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="d-flex justify-content-between mb-1">
                        <span>Park Capacity</span>
                        <strong>{{ Math.round(parkStats.vehiclesInPark / 500 * 100) }}%</strong>
                      </div>
                      <div class="progress">
                        <div class="progress-bar" role="progressbar"
                             :class="parkStats.vehiclesInPark > 400 ? 'bg-danger' : 'bg-info'"
                             :style="{width: (parkStats.vehiclesInPark / 500 * 100) + '%'}">
                        </div>
                      </div>
                    </div>

                    <div class="row text-center mt-3">
                      <div class="col-6">
                        <h5 class="mb-1">{{ averageStayTime }}</h5>
                        <small class="text-muted">Avg. Stay Time</small>
                      </div>
                      <div class="col-6">
                        <h5 class="mb-1">{{ formatPrice(averageTicketValue) }}</h5>
                        <small class="text-muted">Avg. Ticket Value</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Entry Detail Modal -->
        <EntryDetailModal
            :entry="selectedEntry"
            :payments="entryPayments"
            @update-entry="handleUpdateEntry"
            @print-ticket="handlePrintTicket"
        />

        <!-- New Entry Modal -->
        <NewEntryModal
            :feeStructure="feeStructure"
            @entry-created="handleEntryCreated"
        />

        <!-- Group Entry Modal -->
        <GroupEntryModal
            :feeStructure="feeStructure"
            @group-entry-created="handleGroupEntryCreated"
        />

        <!-- Annual Permit Modal -->
        <AnnualPermitModal
            @permit-issued="handlePermitIssued"
        />

        <!-- Alert Toast -->
        <div v-if="alert.success || alert.failed || alert.info"
             class="toast-container position-fixed top-0 end-0 p-3">
          <div class="toast show" role="alert">
            <div class="toast-header" :class="{
                'bg-success text-white': alert.success,
                'bg-danger text-white': alert.failed,
                'bg-info text-white': alert.info
              }">
              <strong class="me-auto"> Park System Notification</strong>
              <button type="button" class="btn-close" @click="clearAlerts"></button>
            </div>
            <div class="toast-body">
              {{ message }}
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <div class="text-sm-start">
                  <i class="mdi mdi-tree text-success me-1"></i>
                   National Park Management System
                </div>
              </div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County Development Team</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */

import { biller, execute, getRight } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import EntryDetailModal from "@/components/park/modals/EntryDetailModal.vue";
import NewEntryModal from "@/components/park/modals/NewEntryModal.vue";
import GroupEntryModal from "@/components/park/modals/GroupEntryModal.vue";
import AnnualPermitModal from "@/components/park/modals/AnnualPermitModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "ParkManagement",
  components: {
    NavigationBar,
    EntryDetailModal,
    NewEntryModal,
    GroupEntryModal,
    AnnualPermitModal
  },
  data() {
    return {
      loading: false,
      searchQuery: '',
      selectedEntryType: '',
      selectedStatus: '',
      selectedDate: '',
      today: moment().format('YYYY-MM-DD'),

      // Park Statistics
      parkStats: {
        todayVisitors: 276,
        todayRevenue: 162300,
        vehiclesInPark: 102,
        activePermits: 97,
        annualPermits: 52
      },

      // Park Entries ( National Park sample data)
      entries: [
        {
          ticketNumber: '-2025071500342',
          visitorName: 'John Smith',
          idNumber: 'PP123456789',
          phoneNumber: '+254712345678',
          entryType: 'NON_RESIDENT',
          visitorCount: 2,
          vehicleReg: 'KAA 123B',
          vehicleType: 'Safari Van',
          entryTime: '2025-07-15 14:30:00',
          entryGate: 'Murera Gate',
          parkFees: 5200,
          vehicleFees: 1500,
          totalFees: 6700,
          paymentMethod: 'Credit Card',
          status: 'IN_PARK',
          duration: null,
          exitTime: null,
          exitGate: null
        },
        {
          ticketNumber: '-2025071500341',
          visitorName: 'Mary Wanjiku',
          idNumber: '12345678',
          phoneNumber: '+254722345679',
          entryType: 'CITIZEN',
          visitorCount: 4,
          vehicleReg: 'KCA 456D',
          vehicleType: 'Personal Car',
          entryTime: '2025-07-15 13:45:00',
          entryGate: 'Kinna Gate',
          parkFees: 800,
          vehicleFees: 300,
          totalFees: 1100,
          paymentMethod: 'M-Pesa',
          status: 'IN_PARK',
          duration: null,
          exitTime: null,
          exitGate: null
        },
        {
          ticketNumber: '-2025071500340',
          visitorName: 'Safari Tours Ltd',
          idNumber: 'BN/2024/12345',
          phoneNumber: '+254733456780',
          entryType: 'NON_RESIDENT',
          visitorCount: 8,
          vehicleReg: 'KBB 789G',
          vehicleType: 'Tour Bus',
          entryTime: '2025-07-15 12:00:00',
          entryGate: 'Murera Gate',
          parkFees: 20800,
          vehicleFees: 2000,
          totalFees: 22800,
          paymentMethod: 'Bank Transfer',
          status: 'EXITED',
          duration: '3h 45m',
          exitTime: '2025-07-15 15:45:00',
          exitGate: 'Kinna Gate'
        },
        {
          ticketNumber: '-2025071500339',
          visitorName: ' University',
          idNumber: 'EDU/2025/001',
          phoneNumber: '+254720000001',
          entryType: 'STUDENT',
          visitorCount: 25,
          vehicleReg: 'KDA 321H',
          vehicleType: 'School Bus',
          entryTime: '2025-07-15 09:00:00',
          entryGate: 'Murera Gate',
          parkFees: 5000,
          vehicleFees: 1000,
          totalFees: 6000,
          paymentMethod: 'Invoice',
          status: 'IN_PARK',
          duration: null,
          exitTime: null,
          exitGate: null
        }
      ],

      filteredEntries: [],

      // Live Activities
      liveActivities: [
        {
          id: 'ACT001',
          type: 'ENTRY',
          description: 'Tourist Van Entry',
          gate: 'Murera Gate',
          time: '14:35:22',
          amount: 6700
        },
        {
          id: 'ACT002',
          type: 'EXIT',
          description: 'Safari Vehicle Exit',
          gate: 'Kinna Gate',
          time: '14:32:15',
          amount: 0
        },
        {
          id: 'ACT003',
          type: 'PAYMENT',
          description: 'Annual Permit Payment',
          gate: 'HQ Office',
          time: '14:30:45',
          amount: 50000
        },
        {
          id: 'ACT004',
          type: 'ENTRY',
          description: 'Local Family Entry',
          gate: 'Kinna Gate',
          time: '14:28:30',
          amount: 1100
        }
      ],

      // Gate Status ( NP gates)
      gateStatus: [
        {
          name: 'Murera Gate',
          status: 'OPEN',
          todayEntries: 164,
          todayExits: 119,
          revenue: 108300
        },
        {
          name: 'Kinna Gate',
          status: 'OPEN',
          todayEntries: 132,
          todayExits: 89,
          revenue: 54000
        }
      ],

      // Fee Structure (sample; adjust to your live tariffs if needed)
      feeStructure: {
        entry: [
          { category: 'Citizen', adult: 200, child: 100 },
          { category: 'Resident', adult: 500, child: 250 },
          { category: 'Non-Resident', adult: 2600, child: 1300 },
          { category: 'Student', adult: 200, child: 100 }
        ],
        vehicle: [
          { type: 'Personal Car', amount: 300 },
          { type: 'Safari Van', amount: 1500 },
          { type: 'Tour Bus', amount: 2000 },
          { type: 'School Bus', amount: 1000 }
        ]
      },

      // Revenue Categories
      revenueCategories: [
        { name: 'Non-Resident', amount: 128000, color: '#0d6efd', icon: 'mdi mdi-airplane' },
        { name: 'Citizen', amount: 22000, color: '#198754', icon: 'mdi mdi-account' },
        { name: 'Vehicles', amount: 10400, color: '#ffc107', icon: 'mdi mdi-car' },
        { name: 'Permits', amount: 2900, color: '#dc3545', icon: 'mdi mdi-card' }
      ],

      // Computed values
      averageStayTime: '4h 12m',
      averageTicketValue: 4975,

      // Modal Data
      selectedEntry: {},
      entryPayments: [],

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    }
  },
  mounted() {
    this.filteredEntries = [...this.entries];
    this.startLiveActivityUpdates();
    this.initializeChart();
    this.menuAccess();
  },
  beforeUnmount() {
    if (this.activityInterval) {
      clearInterval(this.activityInterval);
    }
  },
  methods: {
    getRight,

    // Utility Methods
    formatPrice(value) {
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0
      }).format(value);
    },

    formatNumber(value) {
      return new Intl.NumberFormat('en-KE').format(value);
    },

    formatTime(dateTime) {
      return moment(dateTime).format('HH:mm DD/MM/YYYY');
    },

    getTimeInPark(entry) {
      if (entry.status === 'EXITED') {
        return entry.duration;
      } else if (entry.status === 'IN_PARK') {
        const duration = moment.duration(moment().diff(moment(entry.entryTime)));
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        return `${hours}h ${minutes}m in park`;
      }
      return '';
    },

    gotTo(route) {
      router.push(route);
    },

    // Alert Methods
    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      setTimeout(() => {
        this.clearAlerts();
      }, 5000);
    },

    // Filter Methods
    filterEntries() {
      let filtered = [...this.entries];

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter(entry =>
            entry.ticketNumber.toLowerCase().includes(query) ||
            entry.visitorName.toLowerCase().includes(query) ||
            entry.vehicleReg?.toLowerCase().includes(query) ||
            entry.phoneNumber.includes(query)
        );
      }

      if (this.selectedEntryType) {
        filtered = filtered.filter(entry => entry.entryType === this.selectedEntryType);
      }

      if (this.selectedStatus) {
        filtered = filtered.filter(entry => entry.status === this.selectedStatus);
      }

      if (this.selectedDate) {
        filtered = filtered.filter(entry =>
            moment(entry.entryTime).format('YYYY-MM-DD') === this.selectedDate
        );
      }

      this.filteredEntries = filtered;
    },

    // Badge Methods
    getEntryTypeBadge(type) {
      const badges = {
        'CITIZEN': 'bg-success',
        'RESIDENT': 'bg-info',
        'NON_RESIDENT': 'bg-primary',
        'STUDENT': 'bg-warning',
        'VEHICLE': 'bg-secondary'
      };
      return badges[type] || 'bg-secondary';
    },

    getStatusBadge(status) {
      const badges = {
        'IN_PARK': 'bg-success',
        'EXITED': 'bg-secondary',
        'EXPIRED': 'bg-danger'
      };
      return badges[status] || 'bg-secondary';
    },

    getActivityIcon(type) {
      const icons = {
        'ENTRY': { icon: 'mdi mdi-login', class: 'bg-success' },
        'EXIT': { icon: 'mdi mdi-logout', class: 'bg-info' },
        'PAYMENT': { icon: 'mdi mdi-cash', class: 'bg-primary' },
        'PERMIT': { icon: 'mdi mdi-card-account-details', class: 'bg-warning' }
      };
      return icons[type] || { icon: 'mdi mdi-alert', class: 'bg-secondary' };
    },

    // Live Activity Updates
    startLiveActivityUpdates() {
      this.activityInterval = setInterval(() => {
        // Simulate new activities
        const activities = [
          {
            type: 'ENTRY',
            descriptions: ['Tourist Entry', 'Safari Vehicle', 'Local Visitor', 'Tour Group'],
            amounts: [6700, 1100, 22800, 5000]
          },
          {
            type: 'EXIT',
            descriptions: ['Vehicle Exit', 'Tour Bus Departure', 'Safari Van Exit'],
            amounts: [0, 0, 0]
          },
          {
            type: 'PAYMENT',
            descriptions: ['Permit Renewal', 'Annual Pass', 'Group Booking'],
            amounts: [50000, 30000, 15000]
          }
        ];

        const randomActivity = activities[Math.floor(Math.random() * activities.length)];
        const randomIndex = Math.floor(Math.random() * randomActivity.descriptions.length);

        const newActivity = {
          id: 'ACT' + Date.now(),
          type: randomActivity.type,
          description: randomActivity.descriptions[randomIndex],
          gate: this.gateStatus[Math.floor(Math.random() * this.gateStatus.length)].name,
          time: moment().format('HH:mm:ss'),
          amount: randomActivity.amounts[randomIndex]
        };

        this.liveActivities.unshift(newActivity);
        if (this.liveActivities.length > 10) {
          this.liveActivities.pop();
        }

        // Update statistics
        if (newActivity.type === 'ENTRY') {
          this.parkStats.todayVisitors += Math.floor(Math.random() * 5) + 1;
          this.parkStats.todayRevenue += newActivity.amount;
          this.parkStats.vehiclesInPark++;
        } else if (newActivity.type === 'EXIT') {
          this.parkStats.vehiclesInPark = Math.max(0, this.parkStats.vehiclesInPark - 1);
        }
      }, 5000);
    },

    // Chart Initialization
    initializeChart() {
      // Initialize Chart.js here if needed
    },

    // Entry Operations
    viewEntryDetails(entry) {
      this.selectedEntry = entry;
      this.loadEntryPayments(entry.ticketNumber);
    },

    loadEntryPayments(ticketNumber) {
      // Simulate loading payment details
      this.entryPayments = [
        {
          id: 'PAY001',
          date: '2025-07-15 14:30:00',
          method: 'Credit Card',
          amount: this.selectedEntry.totalFees,
          reference: 'CC-20250715143000',
          status: 'COMPLETED'
        }
      ];
    },

    async recordExit(entry) {
      const exitGate = prompt('Select exit gate:\n1. Murera Gate\n2. Kinna Gate', '1');
      if (exitGate) {
        entry.status = 'EXITED';
        entry.exitTime = moment().format('YYYY-MM-DD HH:mm:ss');
        entry.exitGate = exitGate === '1' ? 'Murera Gate' : 'Kinna Gate';

        const duration = moment.duration(moment().diff(moment(entry.entryTime)));
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        entry.duration = `${hours}h ${minutes}m`;

        this.parkStats.vehiclesInPark--;
        this.showAlert('success', `Exit recorded for ticket ${entry.ticketNumber}`);
      }
    },

    printTicket(entry) {
      // Create ticket print window
      const printWindow = window.open('', '_blank', 'width=850,height=600');

      // Generate ticket HTML updated for  National Park
      const ticketHTML = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Park Entry Ticket - ${entry.ticketNumber}</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet">
          <link href="https://cdn.jsdelivr.net/npm/@mdi/font@6.5.95/css/materialdesignicons.min.css" rel="stylesheet">
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
            * { margin:0; padding:0; box-sizing:border-box; }
            body { font-family:'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif; margin:0; padding:20px; background:#f5f5f5; color:#2c3e50; line-height:1.6; }
            .ticket-container { background:white; width:800px; margin:0 auto; border-radius:12px; overflow:hidden; box-shadow:0 10px 30px rgba(0,0,0,0.1); }
            .ticket-header { background:linear-gradient(135deg, #1e3c72 0%, #2a5298 100%); color:white; padding:25px 30px; position:relative; overflow:hidden; }
            .ticket-header::before { content:''; position:absolute; top:-50%; right:-10%; width:300px; height:300px; background:rgba(255,255,255,0.05); border-radius:50%; }
            .header-content { position:relative; z-index:1; display:flex; justify-content:space-between; align-items:center; }
            .park-info h6 { font-size:12px; font-weight:500; opacity:0.9; margin:0; letter-spacing:1px; text-transform:uppercase; }
            .park-info h4 { font-size:24px; font-weight:700; margin:5px 0; }
            .park-info p { font-size:14px; opacity:0.8; margin:0; }
            .logo-section { display:flex; align-items:center; gap:15px; }
            .logo-section img { height:60px; filter:brightness(0) invert(1); opacity:0.9; }
            .ticket-type { background:${entry.entryType === 'NON_RESIDENT' ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : entry.entryType === 'CITIZEN' ? 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)' : entry.entryType === 'STUDENT' ? 'linear-gradient(135deg, #f2994a 0%, #f2c94c 100%)' : 'linear-gradient(135deg, #56ccf2 0%, #2f80ed 100%)'}; padding:15px 30px; text-align:center; color:white; position:relative; }
            .ticket-type h2 { font-size:20px; font-weight:600; margin:0; letter-spacing:2px; text-transform:uppercase; text-shadow:0 2px 4px rgba(0,0,0,0.1); }
            .ticket-number-section { background:#fafbfc; padding:20px 30px; border-bottom:2px dashed #e0e0e0; display:flex; justify-content:space-between; align-items:center; }
            .ticket-number-box { text-align:center; }
            .ticket-label { font-size:11px; color:#666; text-transform:uppercase; letter-spacing:1px; margin-bottom:5px; }
            .ticket-number { font-size:28px; font-weight:700; color:#2c3e50; letter-spacing:2px; margin:0; }
            .barcode-container { margin-top:10px; padding:10px; background:white; border:1px solid #e0e0e0; border-radius:4px; }
            .barcode { background-image:repeating-linear-gradient(90deg, #000 0px, #000 2px, #fff 2px, #fff 4px); height:50px; width:200px; }
            .qr-section { text-align:center; padding:10px; background:white; border:1px solid #e0e0e0; border-radius:8px; }
            .qr-code { width:100px; height:100px; margin:0 auto 5px; display:flex; align-items:center; justify-content:center; background:#f8f9fa; border-radius:8px; }
            .ticket-content { padding:30px; }
            .visitor-section { margin-bottom:25px; }
            .section-title { font-size:14px; font-weight:600; color:#666; text-transform:uppercase; letter-spacing:1px; margin-bottom:15px; padding-bottom:8px; border-bottom:2px solid #f0f0f0; }
            .info-grid { display:grid; grid-template-columns:repeat(2, 1fr); gap:20px; }
            .info-item { display:flex; flex-direction:column; padding:12px; background:#f8f9fa; border-radius:8px; border:1px solid #e9ecef; }
            .info-label { font-size:11px; color:#666; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:5px; }
            .info-value { font-size:16px; font-weight:600; color:#2c3e50; }
            .info-value.large { font-size:18px; }
            .vehicle-card { background:linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); padding:20px; border-radius:10px; margin-bottom:20px; display:flex; align-items:center; gap:20px; }
            .vehicle-icon { width:60px; height:60px; background:white; border-radius:50%; display:flex; align-items:center; justify-content:center; box-shadow:0 4px 12px rgba(0,0,0,0.1); }
            .vehicle-details h4 { font-size:20px; font-weight:700; color:#1976d2; margin:0 0 5px 0; }
            .vehicle-details p { margin:0; color:#555; font-size:14px; }
            .fee-section { background:#f8f9fa; border-radius:10px; padding:25px; margin-bottom:20px; }
            .fee-table { width:100%; margin-bottom:15px; }
            .fee-row { display:flex; justify-content:space-between; padding:10px 0; border-bottom:1px solid #e0e0e0; }
            .fee-row:last-child { border-bottom:none; }
            .fee-label { color:#666; font-size:14px; }
            .fee-amount { font-weight:600; color:#2c3e50; font-size:16px; }
            .total-row { margin-top:15px; padding-top:15px; border-top:2px solid #333; }
            .total-row .fee-label { font-size:18px; font-weight:600; color:#333; }
            .total-row .fee-amount { font-size:24px; font-weight:700; color:#28a745; }
            .payment-method { text-align:center; margin-top:15px; padding:10px; background:white; border-radius:6px; font-size:13px; color:#666; }
            .activities-container { display:flex; gap:10px; flex-wrap:wrap; margin-top:15px; }
            .activity-badge { background:#28a745; color:white; padding:8px 16px; border-radius:20px; font-size:13px; font-weight:500; display:flex; align-items:center; gap:6px; }
            .rules-section { background:#fff3cd; border:1px solid #ffeeba; border-radius:10px; padding:20px; margin-bottom:20px; }
            .rules-title { font-size:14px; font-weight:600; color:#856404; margin-bottom:10px; display:flex; align-items:center; gap:8px; }
            .rules-grid { display:grid; grid-template-columns:repeat(2, 1fr); gap:10px; }
            .rule-item { font-size:12px; color:#856404; display:flex; align-items:start; gap:6px; }
            .rule-item i { color:#f0ad4e; font-size:14px; margin-top:2px; }
            .ticket-footer { background:#2c3e50; color:white; padding:20px 30px; text-align:center; }
            .emergency-info { display:flex; justify-content:center; gap:30px; margin-bottom:10px; }
            .emergency-item { display:flex; align-items:center; gap:8px; font-size:14px; }
            .emergency-item i { font-size:18px; color:#f39c12; }
            .validity-info { font-size:12px; opacity:0.8; margin-top:10px; }
            .stub-container { position:absolute; right:0; top:0; bottom:0; width:250px; background:#f8f9fa; border-left:2px dashed #ccc; padding:30px 20px; }
            .stub-header { text-align:center; margin-bottom:30px; }
            .stub-title { font-size:16px; font-weight:700; color:#28a745; margin-bottom:5px; }
            .stub-subtitle { font-size:12px; color:#666; }
            .stub-info { background:white; border-radius:8px; padding:15px; margin-bottom:20px; }
            .stub-ticket-number { text-align:center; font-size:18px; font-weight:700; color:#2c3e50; padding:15px; background:#e8f5e9; border-radius:8px; margin-bottom:20px; }
            .stub-detail { margin-bottom:12px; padding-bottom:12px; border-bottom:1px solid #f0f0f0; }
            .stub-detail:last-child { border-bottom:none; margin-bottom:0; padding-bottom:0; }
            .stub-label { font-size:11px; color:#666; text-transform:uppercase; display:block; margin-bottom:3px; }
            .stub-value { font-size:14px; font-weight:600; color:#2c3e50; }
            .stub-footer { text-align:center; padding:15px; background:#28a745; color:white; border-radius:8px; font-size:12px; font-weight:600; margin-top:30px; }
            @media print { body { margin:0; background:white; padding:0; } .ticket-container { box-shadow:none; border-radius:0; } }
          </style>
        </head>
        <body onload="window.print()">
          <div class="ticket-container">
            <!-- Header Section -->
            <div class="ticket-header">
              <div class="header-content">
                <div class="park-info">
                  <h6>Republic of Kenya</h6>
                  <h4> NATIONAL PARK</h4>
                  <p>Kenya Wildlife Service</p>
                </div>
                <div class="logo-section">
                  <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cpath fill='white' d='M50 10 L30 30 L30 60 L50 80 L70 60 L70 30 Z'/%3E%3C/svg%3E" alt="KWS">
                </div>
              </div>
            </div>

            <!-- Ticket Type -->
            <div class="ticket-type">
              <h2>${entry.entryType === 'CITIZEN' ? '🇰🇪 KENYAN CITIZEN' :
          entry.entryType === 'NON_RESIDENT' ? '🌍 INTERNATIONAL VISITOR' :
              entry.entryType === 'STUDENT' ? '🎓 STUDENT GROUP' : '🌍 EAST AFRICAN RESIDENT'}</h2>
            </div>

            <!-- Ticket Number Section -->
            <div class="ticket-number-section">
              <div class="ticket-number-box">
                <div class="ticket-label">Entry Ticket Number</div>
                <div class="ticket-number">${entry.ticketNumber}</div>
                <div class="barcode-container">
                  <div class="barcode"></div>
                </div>
              </div>
              <div class="qr-section">
                <div class="qr-code">
                  <i class="mdi mdi-qrcode" style="font-size: 64px; color: #333;"></i>
                </div>
                <div class="ticket-label">Scan to Verify</div>
              </div>
            </div>

            <!-- Main Content -->
            <div class="ticket-content">
              <!-- Visitor Information -->
              <div class="visitor-section">
                <h3 class="section-title">👤 Visitor Information</h3>
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">Full Name</span>
                    <span class="info-value large">${entry.visitorName}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">ID/Passport Number</span>
                    <span class="info-value">${entry.idNumber}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Contact Number</span>
                    <span class="info-value">${entry.phoneNumber}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Number of Visitors</span>
                    <span class="info-value">${entry.visitorCount} (${entry.adults || entry.visitorCount} Adults, ${entry.children || 0} Children)</span>
                  </div>
                </div>
              </div>

              <!-- Entry Details -->
              <div class="visitor-section">
                <h3 class="section-title">📍 Entry Details</h3>
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">Entry Date & Time</span>
                    <span class="info-value">${moment(entry.entryTime).format('DD MMM YYYY, HH:mm')}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Entry Gate</span>
                    <span class="info-value">${entry.entryGate}</span>
                  </div>
                </div>
              </div>

              <!-- Vehicle Information -->
              ${entry.vehicleReg ? `
                <div class="visitor-section">
                  <h3 class="section-title">🚗 Vehicle Information</h3>
                  <div class="vehicle-card">
                    <div class="vehicle-icon">
                      <i class="mdi mdi-car" style="font-size: 32px; color: #1976d2;"></i>
                    </div>
                    <div class="vehicle-details">
                      <h4>${entry.vehicleReg}</h4>
                      <p>Type: ${entry.vehicleType} ${entry.driverName ? `| Driver: ${entry.driverName}` : ''}</p>
                    </div>
                  </div>
                </div>
              ` : ''}

              <!-- Payment Information -->
              <div class="fee-section">
                <h3 class="section-title" style="margin-bottom: 20px;">💳 Payment Details</h3>
                <div class="fee-table">
                  <div class="fee-row">
                    <span class="fee-label">Park Entry Fees</span>
                    <span class="fee-amount">KES ${entry.parkFees.toLocaleString()}</span>
                  </div>
                  ${entry.vehicleFees > 0 ? `
                    <div class="fee-row">
                      <span class="fee-label">Vehicle Entry Fees</span>
                      <span class="fee-amount">KES ${entry.vehicleFees.toLocaleString()}</span>
                    </div>
                  ` : ''}
                  <div class="fee-row total-row">
                    <span class="fee-label">TOTAL AMOUNT PAID</span>
                    <span class="fee-amount">KES ${entry.totalFees.toLocaleString()}</span>
                  </div>
                </div>
                <div class="payment-method">
                  Payment Method: <strong>${entry.paymentMethod}</strong>
                  ${entry.mpesaCode ? ` | Reference: <strong>${entry.mpesaCode}</strong>` : ''}
                </div>
              </div>

              <!-- Activities -->
              ${entry.activities && Object.values(entry.activities).some(v => v) ? `
                <div class="visitor-section">
                  <h3 class="section-title">✨ Special Activities</h3>
                  <div class="activities-container">
                    ${entry.activities.photography ? '<div class="activity-badge"><i class="mdi mdi-camera"></i> Photography Permit</div>' : ''}
                    ${entry.activities.filming ? '<div class="activity-badge"><i class="mdi mdi-video"></i> Filming Permit</div>' : ''}
                    ${entry.activities.camping ? '<div class="activity-badge"><i class="mdi mdi-tent"></i> Camping Permit</div>' : ''}
                    ${entry.activities.research ? '<div class="activity-badge"><i class="mdi mdi-flask"></i> Research Permit</div>' : ''}
                  </div>
                </div>
              ` : ''}

              <!-- Rules -->
              <div class="rules-section">
                <div class="rules-title">
                  <i class="mdi mdi-alert-circle"></i>
                  IMPORTANT PARK RULES & REGULATIONS
                </div>
                <div class="rules-grid">
                  <div class="rule-item">
                    <i class="mdi mdi-speedometer"></i>
                    <span>Speed limit: 40 km/h maximum</span>
                  </div>
                  <div class="rule-item">
                    <i class="mdi mdi-car"></i>
                    <span>Stay in your vehicle at all times</span>
                  </div>
                  <div class="rule-item">
                    <i class="mdi mdi-food-off"></i>
                    <span>Do not feed or disturb wildlife</span>
                  </div>
                  <div class="rule-item">
                    <i class="mdi mdi-delete"></i>
                    <span>No littering - carry out all waste</span>
                  </div>
                  <div class="rule-item">
                    <i class="mdi mdi-clock"></i>
                    <span>Park hours: 6:00 AM - 6:30 PM</span>
                  </div>
                  <div class="rule-item">
                    <i class="mdi mdi-account-tie"></i>
                    <span>Follow ranger instructions</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer -->
            <div class="ticket-footer">
              <div class="emergency-info">
                <div class="emergency-item">
                  <i class="mdi mdi-phone-alert"></i>
                  <span>Emergency: <strong>999</strong></span>
                </div>
                <div class="emergency-item">
                  <i class="mdi mdi-phone"></i>
                  <span>Park Hotline: <strong>+254 20 2379407</strong></span>
                </div>
              </div>
              <div class="validity-info">
                Valid until: <strong>${moment(entry.entryTime).format('DD MMM YYYY')} at 6:30 PM</strong> |
                Please retain this ticket for exit verification
              </div>
            </div>

            <!-- Visitor Stub -->
            <div class="stub-container">
              <div class="stub-header">
                <div class="stub-title">VISITOR COPY</div>
                <div class="stub-subtitle">Keep for Exit</div>
              </div>

              <div class="stub-ticket-number">
                ${entry.ticketNumber}
              </div>

              <div class="stub-info">
                <div class="stub-detail">
                  <span class="stub-label">Name</span>
                  <span class="stub-value">${entry.visitorName}</span>
                </div>
                <div class="stub-detail">
                  <span class="stub-label">Entry Time</span>
                  <span class="stub-value">${moment(entry.entryTime).format('HH:mm')}</span>
                </div>
                <div class="stub-detail">
                  <span class="stub-label">Vehicle</span>
                  <span class="stub-value">${entry.vehicleReg || 'No Vehicle'}</span>
                </div>
                <div class="stub-detail">
                  <span class="stub-label">Amount Paid</span>
                  <span class="stub-value" style="color: #28a745;">KES ${entry.totalFees.toLocaleString()}</span>
                </div>
              </div>

              <div class="stub-footer">
                PRESENT AT EXIT
              </div>
            </div>
          </div>
        </body>
        </html>
      `;

      printWindow.document.write(ticketHTML);
      printWindow.document.close();
    },

    sendTicketSMS(entry) {
      this.showAlert('info', `Sending SMS to ${entry.phoneNumber}...`);

      setTimeout(() => {
        this.showAlert('success', 'Ticket details sent via SMS');
      }, 2000);
    },

    extendEntry(entry) {
      const hours = prompt('Extend entry by how many hours?', '2');
      if (hours && !isNaN(hours)) {
        this.showAlert('success', `Entry extended by ${hours} hours`);
      }
    },

    voidEntry(entry) {
      const reason = prompt('Reason for voiding this entry:');
      if (reason) {
        entry.status = 'VOIDED';
        this.showAlert('success', `Entry ${entry.ticketNumber} voided`);
      }
    },

    // Modal Operations
    showNewEntryModal() {
      const modal = new bootstrap.Modal(document.getElementById('newEntryModal'));
      modal.show();
    },

    showBulkEntryModal() {
      const modal = new bootstrap.Modal(document.getElementById('groupEntryModal'));
      modal.show();
    },

    showAnnualPermitModal() {
      const modal = new bootstrap.Modal(document.getElementById('annualPermitModal'));
      modal.show();
    },

    editFeeStructure() {
      this.showAlert('info', 'Fee structure editing modal would open here');
    },

    // Event Handlers
    handleEntryCreated(entryData) {
      this.entries.unshift(entryData);
      this.filterEntries();
      this.parkStats.todayVisitors += entryData.visitorCount;
      this.parkStats.todayRevenue += entryData.totalFees;
      this.parkStats.vehiclesInPark++;
      this.showAlert('success', `Entry ${entryData.ticketNumber} created successfully`);
    },

    handleUpdateEntry(updatedData) {
      this.showAlert('success', 'Entry updated successfully');
    },

    handlePrintTicket(ticketNumber) {
      this.printTicket(this.entries.find(e => e.ticketNumber === ticketNumber));
    },

    handleGroupEntryCreated(groupData) {
      // Create individual entries for the group
      const baseEntry = {
        visitorName: groupData.organizationName,
        idNumber: groupData.registrationNumber || groupData.leaderId,
        phoneNumber: groupData.phoneNumber,
        email: groupData.email,
        entryType: groupData.groupType === 'SCHOOL_GROUP' ? 'STUDENT' : 'CITIZEN',
        visitorCount: groupData.totalGroupSize,
        entryTime: `${groupData.entryDate} ${groupData.entryTime}:00`,
        entryGate: groupData.entryGate,
        parkFees: groupData.entryFees + groupData.serviceFees,
        vehicleFees: groupData.vehicleFees,
        totalFees: groupData.totalFees,
        paymentMethod: groupData.paymentMethod,
        status: 'IN_PARK',
        duration: null,
        exitTime: null,
        exitGate: null,
        groupTicket: groupData.ticketNumber
      };

      // Add vehicle entries
      groupData.vehicles.forEach((vehicle, index) => {
        const vehicleEntry = {
          ...baseEntry,
          ticketNumber: `${groupData.ticketNumber}-V${index + 1}`,
          vehicleReg: vehicle.registration,
          vehicleType: vehicle.type,
          driverName: vehicle.driverName
        };
        this.entries.unshift(vehicleEntry);
      });

      this.filterEntries();
      this.parkStats.todayVisitors += groupData.totalGroupSize;
      this.parkStats.todayRevenue += groupData.totalFees;
      this.parkStats.vehiclesInPark += groupData.vehicles.length;

      this.showAlert('success', `Group entry ${groupData.ticketNumber} created successfully for ${groupData.organizationName}`);
    },

    handlePermitIssued(permitData) {
      // Update active permits count
      this.parkStats.activePermits++;
      if (permitData.duration === 12) {
        this.parkStats.annualPermits++;
      }

      // Add to live activities
      const permitActivity = {
        id: 'ACT' + Date.now(),
        type: 'PERMIT',
        description: `${permitData.permitType} Annual Permit`,
        gate: 'HQ Office',
        time: moment().format('HH:mm:ss'),
        amount: permitData.fees.totalFee
      };

      this.liveActivities.unshift(permitActivity);
      if (this.liveActivities.length > 10) {
        this.liveActivities.pop();
      }

      // Update revenue
      this.parkStats.todayRevenue += permitData.fees.totalFee;

      this.showAlert('success', `Annual permit ${permitData.permitNumber} issued successfully to ${permitData.holderName}`);
    },

    // Quick Create Sample Permit (for demonstration)
    createSamplePermit() {
      const samplePermit = {
        permitNumber: '-IND-2025-00342',
        permitType: 'INDIVIDUAL',
        holderName: 'John Kamau Mwangi',
        idNumber: '28456789',
        phoneNumber: '+254722123456',
        email: 'john.kamau@email.com',
        address: 'P.O Box 12345, ',
        county: '',
        beneficiaries: [],
        vehicles: [
          {
            registration: 'KCA 567Y',
            type: 'SUV',
            makeModel: 'Toyota Landcruiser VX',
            color: 'Pearl White'
          },
          {
            registration: 'KDB 234Z',
            type: 'Personal Car',
            makeModel: 'Mercedes-Benz E-Class',
            color: 'Black'
          }
        ],
        startDate: '2025-07-16',
        endDate: '2026-07-15',
        duration: 12,
        privileges: {
          unlimitedEntry: true,
          expressLane: true,
          camping: true,
          guidedTours: false,
          photography: true,
          guestPasses: true
        },
        paymentMethod: 'M-Pesa',
        fees: {
          baseFee: 50000,
          vehicleFees: 5000,
          additionalServices: 10000,
          totalFee: 65000
        },
        status: 'ACTIVE',
        issuedDate: new Date().toISOString(),
        issuedBy: sessionStorage.getItem("sessionNames") || 'System Admin'
      };

      // Handle the permit as if it was just issued
      this.handlePermitIssued(samplePermit);

      // Show the permit card
      setTimeout(() => {
        this.showPermitCard(samplePermit);
      }, 1000);
    },

    showPermitCard(permitData) {
      // Create a modal to display the permit card
      const modalHTML = `
        <div class="modal fade" id="permitCardModal" tabindex="-1">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Annual Permit Card</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">
                <div id="permitCardContent"></div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" onclick="window.print()">
                  <i class="mdi mdi-printer me-2"></i>Print
                </button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      `;

      // Add modal to body if it doesn't exist
      if (!document.getElementById('permitCardModal')) {
        document.body.insertAdjacentHTML('beforeend', modalHTML);
      }

      // Populate permit card content
      const permitCardContent = document.getElementById('permitCardContent');
      if (permitCardContent) {
        permitCardContent.innerHTML = this.generatePermitCardHTML(permitData);
      }

      // Show modal
      const modal = new bootstrap.Modal(document.getElementById('permitCardModal'));
      modal.show();
    },

    generatePermitCardHTML(permit) {
      return `
        <div style="border: 2px solid #000; padding: 20px; background: white;">
          <div style="text-align: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 20px;">
            <h4>REPUBLIC OF KENYA</h4>
            <h5>KENYA WILDLIFE SERVICE</h5>
            <h3 style="color: #28a745;"> NATIONAL PARK</h3>
          </div>

          <div style="background: ${permit.permitType === 'CORPORATE' ? '#6610f2' : permit.permitType === 'FAMILY' ? '#198754' : '#0d6efd'}; color: white; padding: 10px; text-align: center; margin: 0 -20px 20px -20px;">
            <h3>${permit.permitType} ANNUAL PERMIT</h3>
            <h4>${permit.permitNumber}</h4>
          </div>

          <div style="display: flex; gap: 20px; margin-bottom: 20px;">
            <div style="width: 120px; height: 150px; border: 2px solid #ddd; display: flex; align-items: center; justify-content: center; background: #f8f9fa;">
              <div class="text-center">
                <i class="mdi mdi-account" style="font-size: 48px;"></i>
                <small>PHOTO</small>
              </div>
            </div>
            <div style="flex-grow: 1;">
              <table class="table table-sm">
                <tr>
                  <td><strong>Name:</strong></td>
                  <td>${permit.holderName}</td>
                </tr>
                <tr>
                  <td><strong>ID/Passport:</strong></td>
                  <td>${permit.idNumber}</td>
                </tr>
                <tr>
                  <td><strong>Phone:</strong></td>
                  <td>${permit.phoneNumber}</td>
                </tr>
                <tr>
                  <td><strong>Valid From:</strong></td>
                  <td>${moment(permit.startDate).format('DD MMM YYYY')}</td>
                </tr>
                <tr>
                  <td><strong>Valid Until:</strong></td>
                  <td style="color: red; font-weight: bold;">${moment(permit.endDate).format('DD MMM YYYY')}</td>
                </tr>
              </table>
            </div>
            <div style="width: 100px; text-align: center;">
              <div style="width: 100px; height: 100px; border: 1px solid #000; display: flex; align-items: center; justify-content: center;">
                <i class="mdi mdi-qrcode" style="font-size: 64px;"></i>
              </div>
              <small>Scan to Verify</small>
            </div>
          </div>

          <div style="background: #f8f9fa; padding: 15px; border-radius: 8px; margin-bottom: 20px;">
            <h5>PERMIT PRIVILEGES</h5>
            <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px;">
              ${permit.privileges.unlimitedEntry ? '<div><i class="mdi mdi-infinity"></i> Unlimited Entry</div>' : ''}
              ${permit.privileges.expressLane ? '<div><i class="mdi mdi-flash"></i> Express Lane</div>' : ''}
              ${permit.privileges.camping ? '<div><i class="mdi mdi-tent"></i> Camping (50% Off)</div>' : ''}
              ${permit.privileges.photography ? '<div><i class="mdi mdi-camera"></i> Photography</div>' : ''}
              ${permit.privileges.guidedTours ? '<div><i class="mdi mdi-hiking"></i> Guided Tours</div>' : ''}
              ${permit.privileges.guestPasses ? '<div><i class="mdi mdi-ticket"></i> 2 Guest Passes/Month</div>' : ''}
            </div>
          </div>

          <div style="background: #e7f3ff; padding: 15px; border-radius: 8px; margin-bottom: 20px;">
            <h5>REGISTERED VEHICLES</h5>
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Registration</th>
                  <th>Type</th>
                  <th>Make/Model</th>
                  <th>Color</th>
                </tr>
              </thead>
              <tbody>
                ${permit.vehicles.map(v => `
                  <tr>
                    <td><strong>${v.registration}</strong></td>
                    <td>${v.type}</td>
                    <td>${v.makeModel || '-'}</td>
                    <td>${v.color || '-'}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>

          <div style="margin-top: 40px; padding-top: 20px; border-top: 1px solid #ddd;">
            <div style="display: flex; justify-content: space-between;">
              <div>
                <div style="border-bottom: 2px solid #000; width: 200px; height: 40px;"></div>
                <small>Authorized Signature</small>
              </div>
              <div style="text-align: right;">
                <small>Issued: ${moment(permit.issuedDate).format('DD MMM YYYY')}</small><br>
                <small>By: ${permit.issuedBy}</small>
              </div>
            </div>
          </div>
        </div>
      `;
    },

    // Create and print a sample ticket
    createAndPrintSampleTicket() {
      const sampleEntry = {
        ticketNumber: '-2025071600342',
        visitorName: 'Jane Wanjiru Muthoni',
        idNumber: '32145678',
        phoneNumber: '+254722987654',
        entryType: 'CITIZEN',
        visitorCount: 4,
        adults: 2,
        children: 2,
        country: 'KE',
        vehicleReg: 'KDB 789X',
        vehicleType: 'SUV',
        driverName: 'Peter Kamau',
        entryTime: new Date().toISOString(),
        entryGate: 'Murera Gate',
        parkFees: 600,
        vehicleFees: 300,
        totalFees: 900,
        paymentMethod: 'M-Pesa',
        mpesaCode: 'QEF3R5TY8U',
        status: 'IN_PARK',
        activities: {
          photography: true
        }
      };

      // Add to entries
      this.entries.unshift(sampleEntry);
      this.filterEntries();

      // Update stats
      this.parkStats.todayVisitors += 4;
      this.parkStats.todayRevenue += 900;
      this.parkStats.vehiclesInPark++;

      // Show notification
      this.showAlert('success', `Ticket ${sampleEntry.ticketNumber} created successfully`);

      // Print ticket after a short delay
      setTimeout(() => {
        this.printTicket(sampleEntry);
      }, 1000);
    },

    // System Methods
    async menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Park Management");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
.park-card { transition: transform 0.2s; }
.park-card:hover { transform: translateY(-2px); }
.table th { white-space: nowrap; vertical-align: middle; }
.table td { vertical-align: middle; }
.form-label { font-weight: 600; font-size: 0.875rem; }
.badge { font-size: 0.75rem; }
.btn-sm { padding: 0.25rem 0.5rem; font-size: 0.75rem; }
.card-header { padding: 1rem; }
.toast-container { z-index: 9999; }
.avatar-xs { height: 2rem; width: 2rem; }
.avatar-title { align-items: center; display: flex; height: 100%; justify-content: center; width: 100%; }
.progress { height: 8px; }
.card:hover { box-shadow: 0 4px 8px rgba(0,0,0,0.1); transition: box-shadow 0.3s ease; }
@keyframes pulse { 0% { opacity: 1; } 50% { opacity: 0.5; } 100% { opacity: 1; } }
.text-success i.mdi-pulse { animation: pulse 2s infinite; }
canvas { max-height: 300px; }
</style>
